module.exports = __webpack_public_path__ + "img/m8.11e81c82.jpg";